import * as THREE from 'three';

export class ChoiceSquare {
    static THICKNESS = 0.08;
    static SIZE = 1;

    group;
    type;

    constructor(color, x, z, boardSize, type) {
        this.group = new THREE.Group();
        const material = new THREE.MeshBasicMaterial({color: color});

        const top = new THREE.Mesh(new THREE.BoxGeometry(ChoiceSquare.SIZE, 0, ChoiceSquare.THICKNESS), material);
        top.position.set(0, 0, -ChoiceSquare.SIZE / 2 + ChoiceSquare.THICKNESS / 2);
        this.group.add(top);

        const bottom = new THREE.Mesh(new THREE.BoxGeometry(ChoiceSquare.SIZE, 0, ChoiceSquare.THICKNESS), material);
        bottom.position.set(0, 0, ChoiceSquare.SIZE / 2 - ChoiceSquare.THICKNESS / 2);
        this.group.add(bottom);

        const left = new THREE.Mesh(new THREE.BoxGeometry(ChoiceSquare.THICKNESS, 0, ChoiceSquare.SIZE - 2 * ChoiceSquare.THICKNESS), material);
        left.position.set(-ChoiceSquare.SIZE / 2 + ChoiceSquare.THICKNESS / 2, 0, 0);
        this.group.add(left);

        const right = new THREE.Mesh(new THREE.BoxGeometry(ChoiceSquare.THICKNESS, 0, ChoiceSquare.SIZE - 2 * ChoiceSquare.THICKNESS), material);
        right.position.set(ChoiceSquare.SIZE / 2 - ChoiceSquare.THICKNESS / 2, 0, 0);
        this.group.add(right);

        this.group.position.set(
            x - boardSize / 2 + 0.5,
            0.651,
            z - boardSize / 2 + 0.5
        );

        this.group.raycast = () => {};
        this.type = type;
    }

    dispose() {
        if (!this.group) return;

        if (this.group.parent) {
            this.group.parent.remove(this.group);
        }

        const geometries = new Set();
        const materials = new Set();

        this.group.traverse((child) => {
            if (!child.isMesh) return;

            if (child.geometry) {
                geometries.add(child.geometry);
            }

            if (child.material) {
                if (Array.isArray(child.material)) {
                    child.material.forEach((mat) => {
                        if (mat) materials.add(mat);
                    });
                } else {
                    materials.add(child.material);
                }
            }

            child.geometry = null;
            child.material = null;
        });

        geometries.forEach((geometry) => geometry.dispose());
        materials.forEach((material) => material.dispose());

        this.group.clear();
        this.group = null;
    }
}